import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ESellersInfoModalActionTypes {
  Open = 'SellersInfoModal/Open',
  Close = 'SellersInfoModal/Close',
}

export type TOpenSellersInfoModal = ITypedReduxAction<ESellersInfoModalActionTypes.Open>;
export type TCloseSellersInfoModal = ITypedReduxAction<ESellersInfoModalActionTypes.Close>;

export const openSellersInfoModal: () => TOpenSellersInfoModal = actionGenerator<ESellersInfoModalActionTypes.Open>(
  ESellersInfoModalActionTypes.Open,
);

export const closeSellersInfoModal: () => TCloseSellersInfoModal = actionGenerator<ESellersInfoModalActionTypes.Close>(
  ESellersInfoModalActionTypes.Close,
);

export type TSellersInfoModalActions = TOpenSellersInfoModal | TCloseSellersInfoModal;
